import { heroStats } from '@/mocks/comics';

export default function Hero() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-full md:w-3/5 h-full opacity-20 md:opacity-30">
          <img
            src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20and%20manhwa%20collage%20with%20diverse%20comic%20characters%20in%20dynamic%20poses%2C%20warm%20energetic%20atmosphere%2C%20Japanese%20and%20Korean%20comic%20art%20style%20blend%2C%20soft%20gradient%20background%2C%20artistic%20composition%20with%20scattered%20comic%20panel%20elements%2C%20orange%20and%20coral%20accent%20colors&width=1200&height=900&seq=hero-bg-01&orientation=landscape"
            alt="皮皮漫画精选作品合集"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/95 to-background-50/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
            <div className="flex-1 w-full pt-24 md:pt-20 pb-8 md:pb-12">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5">
                <i className="ri-flashlight-line"></i>
                <span>韩漫 · 日漫 · 国漫</span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
                皮皮漫画
                <span className="block text-xl md:text-2xl lg:text-3xl font-sans font-normal text-foreground-600 mt-2">
                  你的掌上漫画图书馆
                </span>
              </h1>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-6">
                皮皮漫画是一个专注韩漫、日漫与国漫的在线免费阅读平台，收录超万部优质漫画作品。
                无论你热爱皮皮漫画韩漫的细腻情感、皮皮漫画日漫的热血冒险，还是皮皮漫画国漫的东方韵味，
                这里都有属于你的精彩世界。每日更新不断档，随时随地打开即读，追漫从未如此轻松。
              </p>

              <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-7">
                {heroStats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-xl md:text-2xl font-heading text-primary-500">{stat.value}</div>
                    <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <a
                  href="#ranking"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScrollTo('#ranking');
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-line"></i>
                  查看热门榜单
                </a>
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScrollTo('#cards');
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 hover:border-primary-400 text-foreground-700 hover:text-primary-500 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-thumb-up-line"></i>
                  精选漫画推荐
                </a>
              </div>
            </div>

            <div className="hidden lg:flex flex-1 items-center justify-center pt-20">
              <div className="relative w-full max-w-md">
                <div className="relative rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dynamic%20collage%20of%20popular%20manga%20manhwa%20and%20manhua%20characters%20in%20action%20poses%2C%20vibrant%20colorful%20comic%20art%20style%2C%20warm%20orange%20and%20coral%20accent%20tones%2C%20energetic%20composition%2C%20Korean%20Japanese%20Chinese%20comic%20fusion%2C%20soft%20gradient%20background%2C%20modern%20clean%20layout&width=600&height=800&seq=hero-main-01&orientation=portrait"
                    alt="皮皮漫画 - 韩漫日漫国漫精选"
                    className="w-full aspect-[3/4] object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-3 -right-3 bg-primary-500 text-white px-4 py-2 rounded-xl text-sm font-heading">
                  每日更新200+话
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}